import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import NotAvailable from '../organisms/NotAvailable'
import { usePolicies } from '../../hooks'

function PolicyNotAvailable ({ policies, ...rest }) {
  const available = usePolicies()
  const enabledCount = useMemo(() => {
    const entries = Object.entries(available)
    const enabled = policies.filter(p => {
      return entries.some(([key, value]) => key === p && value)
    })

    return enabled?.length
  }, [available, policies])

  if (enabledCount === 0) {
    return (
      <NotAvailable {...rest} />
    )
  }

  return null
}

PolicyNotAvailable.propTypes = {
  policies: PropTypes.arrayOf(PropTypes.string)
}

export default PolicyNotAvailable
